import { f7 } from 'framework7-react';
import { FC } from 'react';
import style from './serviceCategorySectionStyle.module.css';
import { paths } from '@/config/paths';
import { UserActionCategory } from '@/types/api/serviceApi';

interface ServiceCategorySectionProps {
  category: UserActionCategory;
  id?: string;
}

export const ServiceCategorySection: FC<ServiceCategorySectionProps> = ({
  category,
  id,
}) => {
  if (
    !category.m_mt_service_categories ||
    category.m_mt_service_categories.length === 0
  ) {
    return null;
  }

  const handleServiceClick = (serviceCategoryId: number) => {
    f7.views.main.router.navigate(
      paths.serviceCategory(serviceCategoryId.toString()),
    );
  };

  return (
    <div id={id} className={style['section-wrapper']}>
      <div className={style['section-header']}>
        <i className={category.icon_class} />
        <span className={style['section-title']}>{category.name}</span>
      </div>

      <div className={style['service-grid']}>
        {category.m_mt_service_categories.map((serviceCategory) => (
          <button
            key={serviceCategory.id}
            className={`${style['service-button']} ${
              serviceCategory.disable_flg ? style['disabled'] : ''
            }`}
            onClick={() =>
              !serviceCategory.disable_flg &&
              handleServiceClick(serviceCategory.id)
            }
            disabled={serviceCategory.disable_flg}
          >
            {serviceCategory.name}
          </button>
        ))}
      </div>
    </div>
  );
};
